import script from "./PaymentCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__